import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../Services/SeoService';
import { LocalizationService } from '../../../Services/localization-service';
interface PaymentPolicyModelItem {
  title: string;
  content: string;
  order: number;
}
interface PaymentPolicyModel {
  items: PaymentPolicyModelItem[];
}
@Component({
  selector: 'app-payment-policy-component',
  imports: [
    TranslatePipe
  ],
  templateUrl: './payment-policy-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './payment-policy-component.scss'
})
export class PaymentPolicyComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly document = inject(DOCUMENT);
  private readonly localizationService = inject(LocalizationService);
  private readonly seoService = inject(SeoService);


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        const canonicalUrl = `${this.document.location.origin}/${lang}/payment-policy`;
        this.seoService.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }
    });
  }


  paymentPolicyModel: PaymentPolicyModel = {
    items: [
      { title: this.translate.instant('PAYMENT_POLICY_TITLE1'), content: this.translate.instant('PAYMENT_POLICY_CONTENT1'), order: 1 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE2'), content: this.translate.instant('PAYMENT_POLICY_CONTENT2'), order: 2 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE3'), content: this.translate.instant('PAYMENT_POLICY_CONTENT3'), order: 3 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE4'), content: this.translate.instant('PAYMENT_POLICY_CONTENT4'), order: 4 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE5'), content: this.translate.instant('PAYMENT_POLICY_CONTENT5'), order: 5 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE6'), content: this.translate.instant('PAYMENT_POLICY_CONTENT6'), order: 6 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE7'), content: this.translate.instant('PAYMENT_POLICY_CONTENT7'), order: 7 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE8'), content: this.translate.instant('PAYMENT_POLICY_CONTENT8'), order: 8 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE9'), content: this.translate.instant('PAYMENT_POLICY_CONTENT9'), order: 9 },
      { title: this.translate.instant('PAYMENT_POLICY_TITLE10'), content: this.translate.instant('PAYMENT_POLICY_CONTENT10'), order: 10 },
    ]
  }
  paymentPolicyStructuredData = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: this.translate.instant('PaymentPolicyDescription'),
    description: this.translate.instant('PaymentPolicyDescription'),
    inLanguage: this.translate.currentLang,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: this.paymentPolicyModel.items.map(item => ({
        '@type': 'ListItem',
        position: item.order,
        name: item.title,
        description: item.content
      }))
    }
  });



}